import $ from 'jquery'

import '../../css/frontend/STI.scss';
import {lazyLoadImages} from './vendor/lazyload.js';
import './utils/CookiesManager.js';
import CookiesManager from "./utils/CookiesManager.js";
import loadjs from 'loadjs';
import MenuManager from "./menu/MenuManager.js";
import Modal from "./utils/Modal.js";
import {init as InitUserDropdown} from './services/user-dropdown.js'
import {initStickyDonateButton} from './services/sticky-donate-button.js'
import {initMobileFormButton} from './services/mobile-form-button.js'
import {initSearchLoading} from './services/search-loading.js'
import {initPushSubscribe} from './services/push-subscribe.js'
import {initPopup} from './services/popup.js'
import './services/auth-state.js';
import OembedHandler from "./utils/OembedHandler.js";
import Parsley from 'parsleyjs';
import ParsleyManager from "./utils/ParsleyManager.js";
import {initInlineComponents} from './components/inline-components/index.js';


if (typeof window !== 'undefined') {
  window.$ = $;
  window.jQuery = $;
  window.jquery = $;
  window.cookiesManager = new CookiesManager();
  window.loadjs = loadjs;
}

const modal = new Modal();

document['modal'] = modal.getBaseModal();
document['errorModal'] = function(text) {
  modal.errorModal(text);
}

const parsleyManager = new ParsleyManager(Parsley);
window.parsleyManager = parsleyManager; // optional, if inline {% js %} blocks need it

$(document).ready(function () {
  lazyLoadImages('.lazy-image', {threshold: 0.7});

  const menuManager = new MenuManager();
  menuManager.init();

  const oembedHandler = new OembedHandler();
  oembedHandler.init();

  InitUserDropdown();
  initStickyDonateButton();
  initMobileFormButton();
  initSearchLoading();
  initPushSubscribe();
  initPopup();

  parsleyManager.loadLocale(window.globalInfo?.siteLanguage);
  initInlineComponents();
});
